module.exports = __webpack_public_path__ + "img/img2.959514fe.svg";